import { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { ConfirmationCustomModal } from '../Shared/ConfirmationModal';
import { ValidatableInput } from '../Shared/ValidatableInput';

interface ServerRebootModalProps {
    show: boolean;
    serverName: string;
    onHide: () => void;
    onConfirm: (reason: string) => void;
}
export function ServerRebootModal({ show, serverName, onHide, onConfirm }: ServerRebootModalProps) {
    const [showIt, setShowIt] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [reason, SetReason] = useState('');
    const [fieldsValidity, setFieldsValidity] = useState(new Map<string, boolean>());

    const setFieldValidity = function (fieldName: string, valid: boolean) {
        const fieldsValidityCopy = new Map(fieldsValidity);
        fieldsValidityCopy.set(fieldName, valid);
        setFieldsValidity(fieldsValidityCopy);
    };

    useEffect(() => {
        const valid = Array.from(fieldsValidity.values()).every((valid) => valid);
        setIsValid(valid);
    }, [fieldsValidity]);

    useEffect(() => {
        SetReason('');
        setShowIt(show);
    }, [show]);

    const restart = () => {
        if (!isValid) {
            return;
        }
        onHide();
        onConfirm(reason);
    };

    return (
        <>
            <ConfirmationCustomModal
                show={showIt}
                enabled={isValid}
                title="Reboot Server Confirmation"
                onCancel={onHide}
                onConfirm={restart}
                cancelVariant="light"
                confirmVariant="danger"
                cancelText="Cancel"
                confirmText={`Reboot ${serverName}`}
            >
                <Row>
                    <p>
                        <ul>
                            <li>
                                There is a chance the server <b>may not</b> come back online automatically. In that scenario contact with appropriate GIS team.
                            </li>
                            <li>
                                All apps (web / windows services) will be <b>shutdown</b>.
                            </li>
                            <li>
                                Interactive users sessions will be <b>shutdown</b> - they will be <b>notified</b>.
                            </li>
                            <li>
                                All owners will be <b>emailed</b>.
                            </li>
                            <li>
                                It will be executed in <b>1 min</b>.
                            </li>
                        </ul>
                    </p>
                </Row>
                <Row>
                    <ValidatableInput
                        focus={true}
                        fieldName={'Reboot Reason'}
                        value={reason}
                        placeholder="Rebooting reason ..."
                        onChange={(value: string) => SetReason(value)}
                        validate={(value: string) => {
                            const errors = [];
                            if (value === undefined || value.length === 0) {
                                errors.push('Reboot reason is required.');
                            }

                            setFieldValidity('Reboot Reason', errors.length === 0);
                            return errors;
                        }}
                    />
                </Row>
            </ConfirmationCustomModal>
        </>
    );
}
